import Banner from "./Banner";  
// import HomeTestimonials from "./HomeTestimonials";   
import About from "./About";
import WhyChooseUs from "./WhyChooseUs";

export default function Home() {
 
  return (
    <div>
      <Banner /> 
      <About />   
      <WhyChooseUs />   
      {/* <HomeTestimonials />  */}
    </div>
  );
}
